import { render, staticRenderFns } from "./MetaInsights.vue?vue&type=template&id=55b869db&scoped=true"
import script from "./MetaInsights.vue?vue&type=script&lang=js"
export * from "./MetaInsights.vue?vue&type=script&lang=js"
import style0 from "./MetaInsights.vue?vue&type=style&index=0&id=55b869db&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b869db",
  null
  
)

export default component.exports